import React from 'react';

// Prices are USD only. The former Indian Rupee conversion (ipstack geolocation +
// currencyapi exchange rates) was removed: Stripe always charged USD regardless,
// so a converted price shown here never matched what the customer was billed.
function PackagePrice(props) {
    const price = props.price != null ? props.price : 0;

    return <span>{props.tax ? "$" + (price + 10) : "$" + Number(price).toFixed(2)}</span>;
}
export default PackagePrice;
